var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e3e3e3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-34q-92.52 0-173.73-35.08-81.21-35.07-141.66-95.53-60.46-60.45-95.53-141.66Q34-387.48 34-480q0-93.14 35.06-173.88 35.07-80.74 95.5-141.43Q225-856 306.24-891q81.24-35 173.76-35 27.52 0 47.76 20.24Q548-885.53 548-858q0 27.53-20.24 47.76Q507.52-790 480-790q-129.35 0-219.67 90.25Q170-609.49 170-480.25 170-351 260.25-260.5q90.26 90.5 219.5 90.5Q609-170 699.5-260.33 790-350.65 790-480q0-27.52 20.24-47.76Q830.47-548 858-548q27.53 0 47.76 20.24Q926-507.52 926-480q0 92.52-35.06 173.77-35.07 81.25-95.5 141.74Q735-104 654.14-69 573.28-34 480-34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.938615f385b54cb403d1de7daa6f5ffe.svg";
export { ForwardRef as ReactComponent };